import React from 'react'
import { GiHamburgerMenu } from "react-icons/gi"
import { Flex, IconButton, useDisclosure, Image, Text } from "@chakra-ui/react"
// import Bag from './Bag'
import {Link} from "react-scroll"
import MobileMenu from './MobileMenu'
const MobileNav = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Flex position={"fixed"}  backgroundColor={"#36454f"} display={{ base: "flex", md: "none" }} justify={'space-between'} p="10px 60px 10px 30px" align="center" w="100%" zIndex={'100'}>
      <IconButton aria-label='hamburger' icon={<GiHamburgerMenu />} onClick={onOpen} />
      <MobileMenu isOpen={isOpen} onClose={onClose} />
      <Link to={"home"} smooth duration={1000} > <Text color={'white'} >Siva</Text></Link>
    </Flex>
  )
}

export default MobileNav